import { createFileRoute } from "@tanstack/react-router";
import { TrustPage } from "@/features/publicinfo/TrustPage";
import { VisitorTours } from "@/tours/VisitorTours";

/** Public trust page. Sits outside the _app layout, so there is no app shell. */
export const Route = createFileRoute("/trust")({
  component: () => (
    <VisitorTours>
      <TrustPage />
    </VisitorTours>
  ),
});
